import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ga',
  months: [
    'Eanáir',
    'Feabhra',
    'Márta',
    'Aibreán',
    'Bealtaine',
    'Meitheamh',
    'Iúil',
    'Lúnasa',
    'Meán Fómhair',
    'Deireadh Fómhair',
    'Samhain',
    'Nollaig',
  ],
  monthsShort: ['Ean', 'Feabh', 'Márta', 'Aib', 'Beal', 'Meith', 'Iúil', 'Lún', 'MFómh', 'DFómh', 'Samh', 'Noll'],
  weekdays: ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Sathairn'],
  weekdaysMin: ['D', 'L', 'M', 'C', 'D', 'A', 'S'],
  weekdaysShort: ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'DD/MM/YYYY',
    'l-Y': 'DD/MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd D MMM YYYY h:mm A',
    'llll-Y': 'ddd D MMM h:mm A',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([MAG]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([MAG]Z)',
  },
  meridiem: { am: 'r.n.', pm: 'i.n.', AM: 'r.n.', PM: 'i.n.' },
  past: {
    y: {
      one: '%s bhl. ó shin',
      two: '%s bhl. ó shin',
      few: '%s bl. ó shin',
      many: '%s mbl. ó shin',
      other: '%s bl. ó shin',
    },
    M: {
      one: '%s mhí ó shin',
      two: '%s mhí ó shin',
      few: '%s mhí ó shin',
      many: '%s mí ó shin',
      other: '%s mí ó shin',
    },
    w: {
      one: '%s scht. ó shin',
      two: '%s shcht. ó shin',
      few: '%s shcht. ó shin',
      many: '%s scht. ó shin',
      other: '%s scht. ó shin',
    },
    d: { one: '%s lá ó shin', two: '%s lá ó shin', few: '%s lá ó shin', many: '%s lá ó shin', other: '%s lá ó shin' },
    h: {
      one: '%s uair ó shin',
      two: '%s uair ó shin',
      few: '%s huaire ó shin',
      many: '%s n-uaire ó shin',
      other: '%s uair ó shin',
    },
    m: {
      one: '%s nóim. ó shin',
      two: '%s nóim. ó shin',
      few: '%s nóim. ó shin',
      many: '%s nóim. ó shin',
      other: '%s nóim. ó shin',
    },
    s: {
      one: '%s soic. ó shin',
      two: '%s shoic. ó shin',
      few: '%s shoic. ó shin',
      many: '%s soic. ó shin',
      other: '%s soic. ó shin',
    },
  },
  future: {
    y: {
      one: 'i gceann %s bl.',
      two: 'i gceann %s bhl.',
      few: 'i gceann %s bl.',
      many: 'i gceann %s mbl.',
      other: 'i gceann %s bl.',
    },
    M: {
      one: 'i gceann %s míosa',
      two: 'i gceann %s mhí',
      few: 'i gceann %s mhí',
      many: 'i gceann %s mí',
      other: 'i gceann %s mí',
    },
    w: {
      one: 'i gceann %s scht.',
      two: 'i gceann %s shcht.',
      few: 'i gceann %s shcht.',
      many: 'i gceann %s scht.',
      other: 'i gceann %s scht.',
    },
    d: {
      one: 'i gceann %s lá',
      two: 'i gceann %s lá',
      few: 'i gceann %s lá',
      many: 'i gceann %s lá',
      other: 'i gceann %s lá',
    },
    h: {
      one: 'i gceann %s uair',
      two: 'i gceann %s uair',
      few: 'i gceann %s huaire',
      many: 'i gceann %s n-uaire',
      other: 'i gceann %s uair',
    },
    m: {
      one: 'i gceann %s nóim.',
      two: 'i gceann %s nóim.',
      few: 'i gceann %s nóim.',
      many: 'i gceann %s nóim.',
      other: 'i gceann %s nóim.',
    },
    s: {
      one: 'i gceann %s soic.',
      two: 'i gceann %s shoic.',
      few: 'i gceann %s shoic.',
      many: 'i gceann %s soic.',
      other: 'i gceann %s soic.',
    },
  },
  abbr: {
    y: { one: '%s bhl', two: '%s bhl', few: '%s bl', many: '%s mbl', other: '%s bl' },
    M: { one: '%s mhí', two: '%s mhí', few: '%s mhí', many: '%s mí', other: '%s mí' },
    w: { one: '%s scht', two: '%s scht', few: '%s scht', many: '%s scht', other: '%s scht' },
    d: { one: '%s lá', two: '%s lá', few: '%s lá', many: '%s lá', other: '%s lá' },
    h: { one: '%s u', two: '%s u', few: '%s u', many: '%s u', other: '%s u' },
    m: { one: '%s nóim', two: '%s nóim', few: '%s nóim', many: '%s nóim', other: '%s nóim' },
    s: { one: '%s soic', two: '%s shoic', few: '%s shoic', many: '%s soic', other: '%s soic' },
  },
  justNow: 'anois',
  yesterday: 'inné',
  today: 'inniu',
  tomorrow: 'amárach',
  weekStart: 1,
};
const localeName: LocaleName = 'ga';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'r.n.' : 'r.n.';
    } else {
      return isLowerCase ? 'i.n.' : 'i.n.';
    }
  },
};
